// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"bot-with-rectangle_rectangle__cpI9X","rectangle__hovered":"bot-with-rectangle_rectangle__hovered__MLC_K","rectangle__bot":"bot-with-rectangle_rectangle__bot__HVBqa"};